async function EductorDelete(edcutorid, deletedbyid) {

    if (true) {

        let response;

        let params = {
            "@EductorID": edcutorid,
            "@DeletedByID": deletedbyid
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "165",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "Eductor",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);
    }
}

export default EductorDelete